// extracted by mini-css-extract-plugin
export default {"semiTitle":"item_semiTitle__rIKyy","lineButtons":"item_lineButtons__LcXh8","headers":"item_headers__Bs9yA","twoInLine":"item_twoInLine__fDcEL","blokInputs":"item_blokInputs__HKM-D"};